import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import "./styles.css"; // Assuming you have a CSS file for styles
import { ExportAs } from "../../../../../_metronic/_helpers/GlobalHelpers";
import { apiCalll } from "../../../../../_metronic/_helpers/apiHelpers";
import moment from "moment";
export default function ExportDataPage() {
  const [startDate, setStartDate] = useState("");
  const [exportType, setExportType] = useState("payouts");
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format) => {
    setIsExporting(true);

    if (exportType === "payouts") {
      ExportPayouts(format);
    }
    if (exportType === "invoices") {
      ExportInvoices(format);
    }
  };

  function ExportPayouts(Type) {
    apiCalll({
      method: "GET",
      link: `/Export/export-payouts?startDate=${startDate}`,
    })
      .then(async (result) => {
        if (result[0] === 200) {
          var listOrders = [];
          var data = result[1].payouts;
          data.map((k) => {
            var a = JSON.stringify(k);
            a = a.replaceAll('"name":', '"Name":');
            a = a.replaceAll('"emailAddress":', '"Email Address":');
            a = a.replaceAll('"payoutDate":', '"Payout Date":');
            a = a.replaceAll('"period":', '"Period":');
            a = a.replaceAll('"netAmount":', '"Net Amount":');
            a = a.replaceAll('"gsthst":', '"GST/HST":');
            a = a.replaceAll('"grossAmount":', '"Gross amount":');
            a = JSON.parse(a);
            listOrders.push(a);
          });
          ExportAs(listOrders || [], Type, `Payouts_${startDate}`);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setIsExporting(false);
      });
  }
  function ExportInvoices(Type) {
    apiCalll({
      method: "GET",
      link: `/Export/export-invoices?startDate=${startDate}`,
    })
      .then(async (result) => {
        if (result[0] === 200) {
          var listOrders = [];
          var data = result[1].invoices;
          data.map((k) => {
            var a = JSON.stringify(k);
            a = a.replaceAll('"customer":', '"Customer":');
            a = a.replaceAll(
              '"chequeOrCreditCard":',
              '"Cheque or Credit Card":'
            );
            a = a.replaceAll('"invoiceDate":', '"Invoice Date":');
            a = a.replaceAll('"period":', '"Period":');
            a = a.replaceAll('"netAmount":', '"Net Amount":');
            a = a.replaceAll('"gsthst":', '"GST/HST":');
            a = a.replaceAll('"grossAmount":', '"Gross amount":');
            a = a.replaceAll('"invoiceNumber":', '"Invoice Number":');
            a = JSON.parse(a);
            listOrders.push(a);
          });
          ExportAs(listOrders || [], Type, `Invoices_${startDate}`);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setIsExporting(false);
      });
  }

  return (
    <div className="accounts-payable-export">
      <div className="export-container">
        <div className="export-card">
          <div className="header">
            <h1>Export Data</h1>
            <p>Select your export preferences and download your data</p>
          </div>

          <div>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="export-form"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="form-group">
                <label
                  htmlFor="startDate"
                  className="form-label font-weight-bold"
                >
                  Start Date
                </label>
                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={(e) => {
                    const date = moment(e.target.value).format("YYYY-MM-DD");
                    setStartDate(date);
                  }}
                  className="date-input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label font-weight-bold">
                  Export Type
                </label>
                <div className="radio-group">
                  <div className="radio-option">
                    <input
                      type="radio"
                      id="payouts"
                      name="exportType"
                      value="payouts"
                      checked={exportType === "payouts"}
                      onChange={(e) => setExportType(e.target.value)}
                      className="radio-input"
                    />
                    <label htmlFor="payouts" className="radio-label">
                      <div className="radio-content">
                        <div className="radio-icon">💰</div>
                        <div>
                          <div className="radio-title">Bills</div>
                          <div className="radio-description">
                            Export all bill transactions
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>

                  <div className="radio-option">
                    <input
                      type="radio"
                      id="invoices"
                      name="exportType"
                      value="invoices"
                      checked={exportType === "invoices"}
                      onChange={(e) => setExportType(e.target.value)}
                      className="radio-input"
                    />
                    <label htmlFor="invoices" className="radio-label">
                      <div className="radio-content">
                        <div className="radio-icon">📄</div>
                        <div>
                          <div className="radio-title">Invoices</div>
                          <div className="radio-description">
                            Export all invoice records
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <div className="w-100">
                <Dropdown>
                  <Dropdown.Toggle
                    disabled={isExporting || !startDate}
                    className={`w-100 p-5 export-button ${
                      isExporting ? "exporting" : ""
                    }`}
                    id="dropdown-basic"
                  >
                    <span className="svg-icon svg-icon-md svg-icon-white">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")}
                      />
                    </span>
                    Export as
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        handleExport("excel");
                      }}
                      href={"#"}
                    >
                      <i className="fas fa-file-excel mr-3"></i> Excel
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        handleExport("csv");
                      }}
                      href="#"
                    >
                      <i className="fas fa-file-csv mr-3"></i> Csv
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        handleExport("json");
                      }}
                      href="#"
                    >
                      <i className="fas fa-file mr-3"></i> Json
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
